import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import productStyle from "assets/jss/westmorland-lodge-44/views/landingPageSections/productStyle.jsx";

class LocationSection extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <GridContainer justify="left">
          <GridItem xs={12} sm={12} md={8}>
            <h5 className={classes.description}>
              Come visit us!
            </h5>
            <br/>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2769.1054397420025!2d-64.09204174858857!3d46.04899507900959!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4b5f6844de2e7329%3A0x600e5438a6e5c0f8!2s3+Church+St%2C+Port+Elgin%2C+NB+E4M+2E1%2C+Canada!5e0!3m2!1sen!2sus!4v1548918972301" width="600" height="450" frameborder="0" allowfullscreen></iframe>
            <br/>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(productStyle)(LocationSection);



// WEBPACK FOOTER //
// ./src/views/LocationPage/Sections/LocationSection.jsx